import React from 'react'

const Statistics = ({ width = 24, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 20"
  >
    <path
      fill="#b18935"
      d="M24,3.875,18,5.1,19.716,6.8l-5.351,5.358-3-3L4.028,16.4l1.41,1.418,5.922-5.834,2.991,2.993,6.781-6.762L22.8,9.877ZM24,20v2H0V2H2V20Z"
      transform="translate(0 -2)"
    />
  </svg>
)

export default Statistics
